export function toNumber (v) {
  if (v == null || v === '') return null
  const n = typeof v === 'number' ? v : Number(v)
  return Number.isFinite(n) ? n : null
}

/**
 * Shared column option resolution for calcKey identity (request + derived reads).
 */
export function resolveColumnOptions (colOptions, globalDateConfig) {
  const mode = colOptions?.dateMode
  if (mode && mode !== 'default') return colOptions

  return {
    ...colOptions,
    dateMode: globalDateConfig.dateMode,
    quickDate: globalDateConfig.quickDate,
    startDate: globalDateConfig.startDate,
    endDate: globalDateConfig.endDate
  }
}
